import { selfGuidedTourSpecTourableSiblings } from 'constants/routes';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, of, catchError } from 'rxjs';

/**
 * Fetches the tourable siblings for a given specId.
 * @param {string} specId - The specId to fetch spec details for.
 * @param {Date} tourDate - The slot date to fetch tourable siblings for.
 * @returns {Observable} An observable that emits the tourable siblings array or an error object.
 */
export default function getSpecTourableSiblings(specId, tourDate) {
  const url = `${selfGuidedTourSpecTourableSiblings}?specId=${specId}&startDate=${tourDate
    .toISOString()
    .replace('Z', '')}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).pipe(
    switchMap((response) => {
      if (response.ok) {
        return response.json();
      }
      return of({ error: true, message: 'Error fetching data' });
    }),
    catchError((error) => of({ error: true, message: error.message }))
  );
}
